export const SubDomainRegex = new RegExp(
  /(?!.*[-]{2,})(?![0-9]+$)(?![-]+)(?!.*[-]+$)^[a-z0-9-]{2,63}$/,
);

export const FullNameRegex = new RegExp(
  /^[a-z]([-']?[a-z]+)*([.])?( [a-z]([-']?[a-z]+)*([.])?)+$/i, // Checks if full name includes at least two words
);

export const MobileNumberRegex = new RegExp(/^(\+)?([ 0-9()-]){7,16}$/);

export const companyNameToDomainName = (companyName: string): string =>
  companyName.toLowerCase().split(' ').join('-');
